export default __webpack_public_path__ + "static/media/3110.2d8239eb.png";